/** @module                             Hooks */

import { useTranslation }               from "react-i18next";

import { usePagename }                  from "../../../Hooks/usePagename";

import { useState, useEffect }          from "react";

import useFetch                         from "../../../Hooks/useFetch";

import { useParams, useNavigate }       from "react-router-dom";

import useUpdate                        from "../../../Hooks/Mutations/useUpdate";

import useRemove                        from "../../../Hooks/Mutations/useRemove";

/** @module                             GQL */

import {

    UPDATE_LEGAL_DATA,

    DELETE_LEGAL_DATA }                 from "../../../Mutations/Contacts";

import { LEGAL_DATA, LEGAL_DATA_LIST }  from "../../../Queries/Contacts";

/** @module                             Components */

import Breadcrumbs                      from "../../../Components/Dashboard/Breadcrumbs";

import AsideEdit                        from "../../../Components/Dashboard/Global/Layouts/Mutations/Aside";

import Fieldset                         from "../../../Components/Dashboard/Global/Forms/Fieldset";

import ComponentLoader                  from "../../../Components/Dashboard/Loaders/ComponentLoader";

import Attributes                       from "../../../Components/Dashboard/Global/Forms/Fieldset/Attributes";

import Checkbox                         from "../../../Components/Dashboard/Global/Forms/Checkbox";

import { LabeledInput }                 from "../../../Components/Dashboard/Global/Forms/Inputs_Spread";

import BankAccountsList                 from "../../../Components/Dashboard/BankAccounts/BankAccountsList";

const

/** @constant DEFINITIONS */

DEFINITIONS = {

    query                           : LEGAL_DATA,

    update_query                    : UPDATE_LEGAL_DATA,

    delete_query                    : DELETE_LEGAL_DATA,

    paramId                         : "legalDataId",

    entryName                       : "adminLegalData",

    collection_url                  : "/app/contacts/legal-data",

    state_collection                : [

        "legalEntityName",

        "registrationNumber",

        "countryCode",

        "legalAddress",

        "factualAddress",

        "phone",

        "servicePhone",

        "email",

        "bankAccounts",

        "id"

    ]

},

/**
 *
 * @param { String } name
 *
 * @returns update mutation
 *
 */

EditLegalData = ( { name } ) => { usePagename ( name ); const

    /**
     *
     *
     * @event useFetch
     *
     * @returns query data, loading state
     *
     */

    { loading, data } = useFetch ( DEFINITIONS.query, {

        id: useParams () [ DEFINITIONS.paramId ]

    } );

    /** @returns */

    return (

        loading || ! data || ! data [ DEFINITIONS.entryName ] ? <section>

            <ComponentLoader />

        </section>

        :

        <UpdateEntry entry={ data [ DEFINITIONS.entryName ] } />

    );

},

/**
 *
 *
 * @param { Object } entry
 *
 * @returns update mutation
 *
 */

UpdateEntry = ( { entry } ) => { const

    { t } = useTranslation (),

    /** @callback useUpdate update mutation hook */

    {

        updateMutation,

        loading,

        complete,

        errors,

        setErrors

    } = useUpdate ( DEFINITIONS.update_query, {

        refetchQueries: [ { query: LEGAL_DATA_LIST }, { query: LEGAL_DATA, variables: { id: entry.id } } ]

    } ),

    /** @event useState form fields */

    [ state, setState ] = useState ( generateEntryState ( entry, DEFINITIONS.state_collection ) ),

    /**
     *
     * @param { Object } e
     *
     * @event onSubmit
     *
     */

    onSubmit = e => { e.preventDefault ();

        if (

            ! state.legalEntityName ||

            ! state.registrationNumber

        ) { return setErrors ( true ); }

        const mutationData = {

            ...state,

            bankAccountsAttributes: formatBankAccountsAttributes ( state.bankAccounts )

        };

        // Remove bankAccounts from the mutation data as we're using bankAccountsAttributes

        delete mutationData.bankAccounts;

        console.log ( "=== Legal Data Update - Frontend ===" );
        console.log ( "State bankAccounts:", state.bankAccounts );
        console.log ( "Formatted bankAccountsAttributes:", mutationData.bankAccountsAttributes );
        console.log ( "Full mutation data:", mutationData );

        updateMutation ( mutationData );

    },

    /**
     *
     * @param { Object } e
     *
     * @event handleChange
     *
     */

    handleChange = e => { const { name, value, type, checked } = e.target;

        if ( type === "checkbox" ) return setState ( prev => ( { ...prev, [ name ]: checked } ) );

        setState ( prev => ( { ...prev, [ name ]: value } ) );

    },

    /**
     *
     * @param { Array } updatedBankAccounts
     *
     * @event handleBankAccountsChange
     *
     */

    handleBankAccountsChange = updatedBankAccounts => {

        setState ( prev => ( { ...prev, bankAccounts: updatedBankAccounts } ) );

    },

    /**
     *
     * @param { Array } bankAccounts
     *
     * @returns formatted bank accounts attributes for GraphQL
     *
     */

    formatBankAccountsAttributes = bankAccounts => {

        if ( ! bankAccounts ) return undefined;

        return bankAccounts.map ( account => ( {

            id: account.id || undefined,

            iban: account.iban,

            bankName: account.bankName,

            swiftCode: account.swiftCode || null,

            isEnabled: account.isEnabled !== undefined ? account.isEnabled : true,

            isDefault: account.isDefault !== undefined ? account.isDefault : false,

            _destroy: account._destroy || false

        } ) );

    };

    /** @returns */

    return (

        <section className="mutations update_entry">

            <Breadcrumbs />

            <form onSubmit={ onSubmit }>

                <AsideEdit aside={

                    <Sidebar

                        __={ t }

                        state={ state }

                        entry={ entry }

                        changeAction={ handleChange }

                        errors={ errors }

                        pending={ loading }

                        success={ complete }

                    />

                }>

                    <Fieldset legend={ t ( "legal_entity_information" ) }>

                        <LabeledInput

                            label={ t ( "legal_entity_name" ) }

                            value={ state.legalEntityName }

                            action={ handleChange }

                            name="legalEntityName"

                        />

                        <LabeledInput

                            label={ t ( "registration_number" ) }

                            value={ state.registrationNumber }

                            action={ handleChange }

                            name="registrationNumber"

                        />

                    </Fieldset>

                    <Fieldset legend={ t ( "contact_information" ) }>

                        <LabeledInput

                            label={ t ( "country_code" ) }

                            value={ state.countryCode || "" }

                            action={ handleChange }

                            name="countryCode"

                            placeholder="LV, EE, etc. (leave empty for default)"

                        />

                        <LabeledInput

                            label={ t ( "legal_address" ) }

                            value={ state.legalAddress || "" }

                            action={ handleChange }

                            name="legalAddress"

                            placeholder="Legal address"

                        />

                        <LabeledInput

                            label={ t ( "factual_address" ) }

                            value={ state.factualAddress || "" }

                            action={ handleChange }

                            name="factualAddress"

                            placeholder="Factual/physical address"

                        />

                        <LabeledInput

                            label={ t ( "phone" ) }

                            value={ state.phone || "" }

                            action={ handleChange }

                            name="phone"

                            placeholder="Shop phone number"

                        />

                        <LabeledInput

                            label={ t ( "service_phone" ) }

                            value={ state.servicePhone || "" }

                            action={ handleChange }

                            name="servicePhone"

                            placeholder="Service phone number"

                        />

                        <LabeledInput

                            label={ t ( "email" ) }

                            value={ state.email || "" }

                            action={ handleChange }

                            name="email"

                            placeholder="Contact email"

                        />

                    </Fieldset>

                    <BankAccountsList

                        bankAccounts={ state.bankAccounts || [] }

                        onChange={ handleBankAccountsChange }

                    />

                </AsideEdit>

            </form>

        </section>

    );

},

/**
 *
 * @param { Object } props
 *
 * @returns sidebar component
 *
 */

Sidebar = ( {

    __,

    state           = "",

    entry           = {},

    changeAction    = () => { return },

    errors          = false,

    pending         = false,

    success         = false

} ) => { const

    navigate = useNavigate (),

    /** @callback useUpdate update mutation hook */

    {

        removeMutation,

        loading,

        complete

    } = useRemove ( DEFINITIONS.delete_query ),

    /**
     *
     * @param { Object } e
     *
     * @description remove entry action
     *
     * @returns redirect to previous page
     *
     */

    removeAction = e => { e.preventDefault ();

        if ( ! state.id ) { return; }

        if ( !state.countryCode ) {

            alert ( __ ( "cannot_delete_default_legal_data" ) );

            return;

        }

        removeMutation ( { id: state.id } );

    };

    /** @event useEffect */

    useEffect ( () => {

        ( complete === true ) &&

            navigate ( DEFINITIONS.collection_url );

    }, [ complete ] );

    /** @returns */

    return (

        <aside>

            <Fieldset legend={ __ ( "actions" ) }>

                { success && ! errors &&

                    <div className="success">

                        <div className="success_message">

                            { __ ( "successfully_updated" ) }

                        </div>

                    </div>

                }

                { errors && <div className="errors">

                    <div className="error">

                        { __ ( "error_ocurred" ) }

                    </div>

                </div> }

                <Attributes details={ [

                    { name: __ ( "createdAt" ), value: new Date ( entry.createdAt ).toLocaleString () },

                    { name: __ ( "updatedAt" ), value: new Date ( entry.updatedAt ).toLocaleString () },

                ] } />

                <div className={ `mutation-actions default` }>

                    <button className="button add" disabled={ pending || loading }>

                        { __ ( "submit" ) }

                    </button>

                    <button

                        className="button remove"

                        type="button"

                        disabled={ pending || loading || !state.countryCode }

                        onClick={ removeAction } >

                            { __ ( "delete" ) }

                    </button>

                </div>

            </Fieldset>

            {/*<Fieldset legend={ __ ( "options" ) }>*/}

            {/*    <Checkbox*/}

            {/*        label={ __ ( "is_default" ) }*/}

            {/*        value={ state.isDefault }*/}

            {/*        action={ changeAction }*/}

            {/*        name="isDefault"*/}

            {/*    />*/}

            {/*</Fieldset>*/}

        </aside>

    );

},

/**
 *
 * @param { Object } entry
 *
 * @param { Array } collection
 *
 * @returns state object
 *
 */

generateEntryState = ( entry, collection ) => { let

    state = {};

    collection.forEach ( item => {

        state [ item ] = entry [ item ];

    } );

    return state;

};

/** @exports EditLegalData */

export default EditLegalData;
